import React, { FC } from "react";
import {
  PageEnum,
  SuppliersComplexReportSearchParamsModel,
} from "../../../models";
import {
  getPageNameByPageId,
  getSystemLanguageId,
  getUserId,
} from "../../../utils";
import { searchReportSuppliersAccount } from "../../../serviceBroker/suppliersReportApiServiceBroker";
import { ReportPage } from "../../../components";
import { reportSuppliersAccountSearchPanel } from "../../../components/reports/suppliers/reportSuppliersAccountSearchPanel";

export const ReportSuppliersAccount: FC = () => {
  const initialState: SuppliersComplexReportSearchParamsModel = {
    Lang: getSystemLanguageId(),
  };
  return (
    <ReportPage
      InitialState={initialState}
      SearchApi={searchReportSuppliersAccount}
      searchHeader={getPageNameByPageId(PageEnum.ReportAccountOfSupplier)}
      SearchPanel={reportSuppliersAccountSearchPanel}
      formId={PageEnum.ReportAccountOfSupplier}
    />
  );
};
